import { render, staticRenderFns } from "./LocalityUserFilter.vue?vue&type=template&id=88a078be"
import script from "./LocalityUserFilter.vue?vue&type=script&lang=js"
export * from "./LocalityUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports